import { Component } from '@angular/core';
import { Datalistviewcolumn, StarRatingViewColumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-valetsurveys',
    templateUrl: './valetsurveys.component.html',
    styleUrls: ['./valetsurveys.component.scss'],
    standalone: false
})
export class ValetSurveysComponent {
  constructor() { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Id", "Id"),
    new Datalistviewcolumn("Session Ticket #", "TicketNumber"),
    new Datalistviewcolumn("Session ID", "ValetParkingSessionId"),
    new Datalistviewcolumn("Station", "ValetStationName"),
    new Datalistviewcolumn("Received", "ReceivedAtLocalFriendlyString"),
    new StarRatingViewColumn("Rating", "Rating"),
    new Datalistviewcolumn("Survey", "TruncatedSurvey")
  ];
}
